<template>
  <div>
    <div class="card" :class="$style.container">
      <div class="text-dark font-size-24 mb-4">
        <strong>Reset password</strong>
      </div>
      <a-form class="mb-4" :form="form">
        <a-form-item>
          <a-input
            size="large"
            placeholder="Email"
            v-decorator="[
              'email',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please type your email',
                  },
                ],
              },
            ]"
          />
        </a-form-item>

        <a-form-item>
          <a-input
            size="large"
            type="password"
            placeholder="New password"
            v-decorator="[
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please type new password!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item>
          <a-input
            size="large"
            type="password"
            placeholder="Retype password"
            v-decorator="[
              'password_confirmation',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please retype your password.',
                  },
                ],
              },
            ]"
          />
        </a-form-item>

        <p>
          <strong
            >Please make sure your password is at least 8 characters
            long.</strong
          >
        </p>

        <a-button
          size="large"
          type="primary"
          class="text-center w-100"
          @click.prevent="submitResetPassword"
        >
          <strong>Set new password</strong>
        </a-button>
      </a-form>
      <router-link to="/auth/login" class="kit__utils__link font-size-16">
        <i class="fe fe-arrow-left mr-1 align-middle" />
        Back to SignIn
      </router-link>
    </div>
  </div>
</template>
<script>
import { notification } from 'ant-design-vue'
import apiClient from '@/services/axios'

export default {
  name: 'CuiResetPassword',
  data: function () {
    return {
      form: this.$form.createForm(this),
    }
  },
  methods: {
    submitResetPassword() {
      this.form.validateFields((err, values) => {
        if (!err) {
          apiClient
            .post('/auth/reset/password', {
              ...values,
              token: this.$route.params.token,
            })
            .then(
              (result) => {
                console.log(result)
                if (result.data.errors) {
                  this.$notification['error']({
                    message: 'Password reset failed',
                    description: result.data.errors.join('. '),
                  })
                } else {
                  this.$notification['success']({
                    message: 'Password reset successfull',
                    description:
                      'You will be redirected to login page shortly.',
                  })

                  // navigate to login
                  this.$router.push({ path: '/auth/login' })
                }
              },
              (error) => {
                const errors = error.response.data.errors
                for (var prop in errors) {
                  this.$notification['error']({
                    message: 'Error',
                    description: errors[prop],
                  })
                }
                this.$notification['error']({
                  message: 'Password reset failed',
                  description: 'Password reset failed. Please try again later.',
                })
              }
            )
        } else {
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import '@/components/cleanui/system/Auth/style.module.scss';
</style>
